import { PRODUCTION, DEVELOPMENT, API_DEV_URL } from "./const";
import { isEmpty } from "lodash";

export function baseUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const API_URL = !!process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== "" ? process.env.REACT_APP_API_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return API_DEV_URL;
      case PRODUCTION:
        return API_URL;
      default:
        return API_DEV_URL;
    }
  } else {
    return API_DEV_URL;
  }
}

export const getApiUrl = (path) => {
  return `${baseUrl()}/${path}`;
};

export const getComplianceSocketUrl = (path) => {
  const baseUrl = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace("https://", "") : API_DEV_URL.replace("http://", "").replace("https://", "");
  return `wss://${baseUrl}/ws/${path}`;
};
